export default "__VITE_ASSET__qLJYRfIL__"